import React from 'react';
import { FormLabel, FormValue } from '../Form/FormLabel';
import { Button } from 'reactstrap'
import { Route, useHistory } from 'react-router-dom';
import Editor from '../Models/Editor';
import entities from '../../utils/entities';

const ClientStaffDetail = ({ route,clientStaff }) => {
    const history = useHistory();
    const { id, firstName, lastName, email, status, phoneNumber } = { ...clientStaff };
    const setItemId = (id) => id ? history.push(route + "/staff/" + id + '/Detail') : history.push(route);
    return <React.Fragment>
        <FormLabel><Button size='sm' onClick={() => setItemId(id)} > Staff ({status})</Button></FormLabel>
        <FormValue> {firstName} {lastName} {email}  {phoneNumber}</FormValue>
        <Route path={route + '/staff/:clientStaffId/:departmentAction'} render={({ match }) => <Editor route={route + '/staff'} entity={entities.clientStaff} itemId={match.params.clientStaffId} editorClosed={() => setItemId()} />} />

    </React.Fragment>
};
export default ClientStaffDetail; 




